import 'react-picky/dist/picky.css';
import React, {Component} from 'react';
import {FormattedMessage, injectIntl} from 'react-intl';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import get from 'get-value';
import PropTypes from 'prop-types';
import {
    lockCommercialTicket,
    resetRedirectAfterLockCommercialTicket
} from '../../../actions/commercial/actionCommercialLockTicket';
import {
    fetchCommercialPreferences,
    updateCommercialUserListPreference
} from '../../../actions/commercial/actionCommercialPreferences';
import {clearAlerts} from '../../../actions/alertsActions';
import {ColumnLibrary} from '../../common/table/ColumnLibrary';
import {StyledPicky} from '../../common/StyledComponents';
import {domains} from '../../../constants/Utils';
import ListCommercialTable from './ListCommercialTable';
import checkRoles from '../../common/roleChecker/RoleChecker';
import Loader from '../../Loader';
import PageHeader from '../../common/PageHeader';
import listMessages from '../../../intl/modules/listMessages';
import tableMessages from '../../../intl/common/tableMessages';

const domain = domains.COMMERCIAL;

class ListCommercialPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ratchet: false,
        }
    }

    componentWillUnmount() {
        this.props.resetRedirectAfterLockCommercialTicket();
    }

    componentDidMount() {
        this.props.fetchCommercialPreferences();
    }

    handleEditClick = ({id}) => {
        if (!this.props.lockTicket.isTicketLocking) {
            this.props.lockCommercialTicket(id);
            this.setState({ratchet: true})
        }
    };

    render() {
        const {intl, commercialPreferences, lockTicket, location, isLoadingSubjects} = this.props;
        const columnLibrary = ColumnLibrary(this.props, domain);
        const selectMultipleOption = (value) => {
            this.props.updateCommercialUserListPreference(
                columnLibrary.filter(item => !value.some(value => value.id === item.id)).map(column => column.id))
        };

        if (lockTicket.redirect && this.state.ratchet) {
            this.props.history.push(`/commercial/edit/${lockTicket.uuid}`);
        }
        if (commercialPreferences.isLoading
            || isLoadingSubjects
        ) {
            return <Loader/>;
        }

        return (
            <div className="container-fluid">
                <PageHeader title={<FormattedMessage {...listMessages.TITLE}/>}/>
                <div className="d-flex justify-content-end mb-3">
                    <div className="col-xl-4 col-lg-7 col-md-9 col-sm-12">
                        <span className="font-weight-bold">
                            <FormattedMessage {...tableMessages.VISIBLE_COLUMNS}/>
                            {':'}
                        </span>
                        <StyledPicky
                            value={columnLibrary.filter(item => !get(
                                commercialPreferences,
                                'menuList',
                                {default: []}).includes(item.id)).map(col => {
                                return {id: col.id, message: intl.formatMessage(col.message)}
                            })}
                            options={columnLibrary.map(col => {
                                return {id: col.id, message: intl.formatMessage(col.message)}
                            })}
                            onChange={selectMultipleOption}
                            open={false}
                            valueKey="id"
                            labelKey="message"
                            multiple={true}
                            includeSelectAll={true}
                            includeFilter={false}
                            dropdownHeight={600}
                        />
                    </div>
                </div>
                <ListCommercialTable
                    columns={
                        columnLibrary.filter(item =>
                            !get(commercialPreferences, 'menuList', {default: []}).includes(item.id))
                    }
                    handleEditClick={this.handleEditClick}
                    location={location}
                />
            </div>
        );
    }
}

ListCommercialPage.propTypes = {
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    clearAlerts: PropTypes.func.isRequired,
    updateCommercialUserListPreference: PropTypes.func.isRequired,
    lockCommercialTicket: PropTypes.func.isRequired,
    resetRedirectAfterLockCommercialTicket: PropTypes.func.isRequired,
    intl: PropTypes.any.isRequired,
};

const mapStateToProps = state => ({
    commercialPreferences: state.commercialPreferences,
    lockTicket: state.commercialListOrderLockTicketCheck,
    isLoadingSubjects: state.adminSubjectSettings.isLoading,
    subjects: state.adminSubjectSettings.subjectSettings.subjects,
    listData: state.commercialList.listData,
    userDetail: state.profile.userDetail,
});

export default checkRoles(withRouter(connect(mapStateToProps, {
    clearAlerts,
    updateCommercialUserListPreference,
    fetchCommercialPreferences,
    lockCommercialTicket,
    resetRedirectAfterLockCommercialTicket,
})(injectIntl(ListCommercialPage))), ['CC_DEALER', 'CC_EDITOR']);
